import styled from "styled-components";

export const ContainerFilledCircle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const FilledCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;
